<template>
  <div class="spacer">
    <div class="glass-overlay">
      <div class="noData" v-if="
        (viewerId != null && viewerId != '' && !currentViewer) ||
        brandId == null
      ">
      </div>
      <div v-else>
        <img v-if="viewerId == '' || viewerId == null || !currentViewer" class="brandLogoSelector"
          src="../../assets/img/tiget-b.jpg" />
        <div class="modelSelector" v-if="viewerId == '' || viewerId == null || !currentViewer">
          <div :class="!mobileLayout ? 'modelSelectionArea' : 'modelSelectionAreaMobile'">
            <!-- PC端分组展示模型 -->
            <div v-if="!mobileLayout">
              <div v-for="(group, groupIndex) in industryGroups" :key="groupIndex" class="modelGroup">
                <div class="groupHeader" @click="toggleGroup(groupIndex)">
                  <div class="groupTitleBox">
                    <span class="groupTitleText">{{ group.title }}</span>
                  </div>
                  <div class="groupArrow" :class="{ expanded: expandedGroups[groupIndex] }">
                    <i class="el-icon-d-arrow-right"></i>
                  </div>
                </div>
                <div class="modelCardsContainer" v-show="expandedGroups[groupIndex] !== false">
                  <div class="modelSelectCard" v-for="(model, index) in group.models" v-bind:key="index">
                    <div @click="showViewer(model, true)">
                      <img class="modelSelectImage" :src="model.picUrl" />
                      <div class="modelTitle">{{ viewerTitle(model.viewerTitle) }}</div>
                    </div>
                  </div>
                </div>
                <div class="groupSeparator" v-if="groupIndex < industryGroups.length - 1"></div>
              </div>
            </div>

            <!-- 移动端下拉选择器 + 网格布局 -->
            <div v-else class="mobileModelSelector">
              <div class="mobileIndustrySelector">
                <el-select v-model="selectedMobileIndustry" placeholder="选择行业" @change="onMobileIndustryChange"
                  popper-class="mobile-industry-dropdown">
                  <el-option label="全部模型" value="all"></el-option>
                  <el-option label="交通运输" value="0"></el-option>
                  <el-option label="建筑建材" value="1"></el-option>
                  <el-option label="通用工业" value="2"></el-option>
                  <el-option label="绿色生活" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </div>

              <div class="mobileModelGrid">
                <div class="modelSelectCard" v-for="(model, index) in filteredMobileModels" v-bind:key="index">
                  <div @click="showViewer(model, true)">
                    <img class="modelSelectImage" :src="model.picUrl" />
                    <div class="modelTitle">{{ viewerTitle(model.viewerTitle) }}</div>
                  </div>
                </div>
              </div>

              <div class="empty" v-if="filteredMobileModels.length == 0">
                暂无此类模型
              </div>
            </div>

            <div class="empty" v-if="industryGroups.length == 0">
              暂无此类模型
            </div>
          </div>
        </div>

        <div class="modelViewer" v-else>
          <div class="mobileTopMenu" v-if="mobileLayout">
            <button class="modelNameTrigger" type="button" title="切换到TIGER 2026趋势色彩与饰面"
              @click="openMaterialBallViewer">
              {{ viewerTitle(currentViewer.viewerTitle) }}
            </button>
            <div style="font-size: 26px; margin-top: 3px; margin-right: 5px" @click="sharingWindowOpen = true">
              <i class="el-icon-share"></i>
            </div>
          </div>
          <div class="topMenu" v-else>
            <button class="modelNameTrigger" type="button" title="切换到TIGER 2026趋势色彩与饰面"
              @click="openMaterialBallViewer">
              {{ viewerTitle(currentViewer.viewerTitle) }}
            </button>
            <div></div>
          </div>

          <div v-if="sharingWindowOpen" class="sharingWindowContentBlocker"></div>
          <div v-if="sharingWindowOpen" class="sharingWindow">
            <div class="sharingTitle">
              <el-button icon="el-icon-close" class="sharingCloseButton" type="text"
                @click="sharingWindowOpen = false"></el-button>
              分享
              <vue-qr :text="link" :size="150" />
            </div>
          </div>

          <div class="arButton" @click="startAr()" v-if="isArAvailable">
            <!-- <div style="display: block; background-color: white; height: 35px; width: 35px"></div> -->
            <img src="../../assets/ar_logo.png" height="35" width="35" style="margin: 6px 5px 5px 15px" />
            <div style="display: inline-block; padding: 12px 15px 5px 0px">
              Try out in AR
            </div>
          </div>

          <div id="emersyaMainViewer" :style="{
            height: viewerHeight,
            width: !mobileLayout
              ? displayCustomize
                ? 'calc(100% - 515px)'
                : '100%'
              : '100%'
          }"></div>

          <div v-if="!hasInitiatedViewer" :style="{ height: viewerHeight }" class="iframeLoadingScreen">
            <div>
              <svg-icon icon-class="product_placeholder" class-name="colorTrendsLoadingLogo"
                aria-label="正在加载模型" />
            </div>
          </div>

          <!-- PC版本UI （选择颜色） -->
          <div v-if="!mobileLayout">
            <div class="closedCustomize" v-if="!displayCustomize">
              <i class="el-icon-edit-outline" @click="toggleCustomizeDisplay()">&nbsp;{{ $t('customize') }}</i>
            </div>
            <div class="materialSelectorArea" v-else>
              <div class="sectionTitle" style="cursor: pointer" @click.stop="toggleCustomizeDisplay()">
                {{ $t('customize') }} <i class="el-icon-arrow-right"></i>
              </div>
              <div class="materialBox">
                <div class="colorTrendsCategory" v-for="category in colorTrendsCategories" :key="category.name">
                  <div class="colorTrendsCategoryTitle" @click="toggleColorTrendsCategory(category.name)">
                    <span>{{ category.name }}</span>
                    <i :class="expandedColorTrendsCategories[category.name]
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'"></i>
                  </div>
                  <div class="materialArea" v-if="expandedColorTrendsCategories[category.name]">
                    <el-card class="materialSelectCard" v-for="material in category.materials" :key="material.key"
                      :body-style="{ padding: '5px' }" :style="{
                        border:
                          currentMaterials[material.groupName] == material.configurationName
                            ? '2px solid #97c11c'
                            : undefined
                      }">
                      <div @click="selectMaterial(material.groupName, material.configurationName)">
                        <div class="materialCode">{{ material.configurationName }}</div>
                        <img class="materialPreview" :src="material.image" />
                      </div>
                    </el-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部模型选择菜单（PC端和移动端） -->
        <div v-if="viewerId != '' && viewerId != null && currentViewer" class="modelSelectMenu">
          <!-- PC端底部模型选择栏 -->
          <div v-if="!mobileLayout">
            <div class="modelSelectMenuArrow" @click="toggleBottomBarModelsDisplay">
              <i class="el-icon-arrow-down" v-if="displayBottomModels"></i>
              <i class="el-icon-arrow-up" v-else></i>
              <div v-if="!displayBottomModels">显示所有模型</div>
            </div>
            <div class="modelSelectMenuBar"></div>
            <div v-if="displayBottomModels" class="container">
              <!-- 底部模型卡片 -->
              <div class="modelSelectCard" v-for="(model, index) in filteredViewers" v-bind:key="index">
                <div @click="showViewer(model, true)">
                  <div class="modelTitle">{{ viewerTitle(model.viewerTitle) }}</div>
                  <img class="modelSelectImage" :src="model.picUrl" />
                </div>
              </div>
            </div>
          </div>

          <!-- 移动端底部模型/颜色选择菜单 -->
          <div ref="mobileBottomSelectMenu" class="mobileBottomSelectMenu" v-else>
            <div style="position: relative">
              <!-- 颜色选择菜单 -->
              <div class="menuSegment colorMenuSegment">
                <div class="title" @click="toggleMobileBottomBarColorsDisplay">
                  <i class="el-icon-arrow-up arrow" v-if="!displayMobileBottomColors"></i>
                  <i class="el-icon-arrow-down arrow" v-else></i>
                  {{ $t('color') }}
                  <span v-if="selectedGroup && currentMaterials[selectedGroup]">: {{ $t(selectedGroup) }} ({{ selectedGroup }})</span>
                </div>
                <div class="colorsContent" v-if="displayMobileBottomColors">
                  <div class="colorTrendsCategoryList">
                    <div class="colorTrendsCategory" v-for="category in colorTrendsCategories" :key="category.name">
                      <div class="colorTrendsCategoryTitle" @click="toggleColorTrendsCategory(category.name)">
                        <span>{{ category.name }}</span>
                        <i :class="expandedColorTrendsCategories[category.name]
                          ? 'el-icon-arrow-up'
                          : 'el-icon-arrow-down'"></i>
                      </div>
                      <div class="materialArea" v-if="expandedColorTrendsCategories[category.name]">
                        <div class="materialSelectCard" v-for="material in category.materials" :key="material.key"
                          :style="{
                            border:
                              currentMaterials[material.groupName] == material.configurationName
                                ? '2px solid #97c11c'
                                : undefined
                          }" @click="selectMaterial(material.groupName, material.configurationName)">
                          <div class="materialCode">{{ material.configurationName }}</div>
                          <img class="materialPreview" :src="material.image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 模型选择菜单 -->
              <div class="menuSegment modelMenuSegment">
                <div class="title" @click="toggleMobileBottomBarModelsDisplay">
                  <i class="el-icon-arrow-up arrow" v-if="!displayMobileBottomModels"></i>
                  <i class="el-icon-arrow-down arrow" v-else></i>
                  3D模型
                  <span v-if="hasInitiatedViewer">: {{ viewerTitle(currentViewer.viewerTitle) }}</span>
                </div>
                <div class="modelsContent" v-if="displayMobileBottomModels">
                  <!-- 底部模型卡片 -->
                  <div class="modelSelectCard" v-for="(model, index) in filteredViewers" v-bind:key="index">
                    <div @click="showViewer(model, true)">
                      <img class="modelSelectImage selected" :src="model.picUrl" v-if="viewerId == model.viewerId" />
                      <img class="modelSelectImage" :src="model.picUrl" v-else />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* global emViewers */
import {
  getBrandLogoApi,
  getViewerInfoApi,
  getProductInfoBulkApi,
  getAllMaterialGroupsApi,
  addClick,
  addAccessLog,
  emersyaLogin,
  emersyaLogout
} from '@/api/modules/modelViewer'
import VueQr from 'vue-qr'
import Cookies from "js-cookie";
const colorTrendsFilter = require('./filter.cjs')
const { getViewerTitle } = require('../modelViewerScreen/materialLabel')
const {
  filterColorTrendsViewers,
  getColorTrendsMaterialBallViewer,
  getColorTrendsListViewers,
  getColorTrendsMaterialImageKey,
  groupColorTrendsMaterialImages,
  toggleColorTrendsCategoryState
} = colorTrendsFilter
const colorTrendsMaterialImageContext = require.context(
  '../../assets/img/colorTrendsMaterials',
  true,
  /\.png$/
)
const colorTrendsMaterialImages = {}
const colorTrendsMaterialImageEntries = []
colorTrendsMaterialImageContext.keys().forEach((path) => {
  const key = getColorTrendsMaterialImageKey(path)
  const category = path.split('/')[1]
  const image = colorTrendsMaterialImageContext(path)
  colorTrendsMaterialImages[key] = image
  colorTrendsMaterialImageEntries.push({ category, key, image })
})
const colorTrendsMaterialCatalog = groupColorTrendsMaterialImages(colorTrendsMaterialImageEntries)
export default {
  data() {
    return {
      refreshInterval: null,
      mobile: '',
      userName: '',
      companyName: '',
      urlFrom: '',
      mobileLayout: false,
      presetConfigurationName: [],
      presetGroupName: [],
      brandId: '',
      emersyaSessionId: '',
      previousViewerId: '',
      viewerId: '',
      selectedGroup: '',
      type: '',
      industries: [
        { value: '0', label: '交通运输' },
        { value: '1', label: '建筑建材' },
        { value: '2', label: '通用工业' },
        { value: '3', label: '绿色生活' },
        { value: '4', label: '其他' }
      ],
      selectedIndustry: '0',
      viewerHeight: 0,
      hasInitiatedViewer: false,
      viewerActive: false,
      previousMaterialGroupInfo: null,
      brandLogoURL: '',
      viewers: [],
      materialGroups: [],
      currentMaterials: {},
      currentProductNo: 'Loading...',
      currentProductInfo: {
        productCategory: '',
        surface: '',
        gloss: '',
        productPerformance: '',
        hex: ''
      },
      productInfoExpanded: false,
      sharingWindowOpen: false,
      isArAvailable: false,
      displayBottomModels: false,
      displayMobileBottomModels: false,
      displayMobileBottomColors: false,
      displayCustomize: false,
      cachedModels: [],
      timer: null,
      cachedProductList: {},
      expandedGroups: [], // 新增：用于控制分组是否展开
      selectedMobileIndustry: 'all', // 新增：移动端选择的行业
      expandedColorTrendsCategories: {}
    }
  },
  components: {
    VueQr
  },
  computed: {
    // 行业分组映射
    industryGroups() {
      const industryMap = {
        '0': '交通运输',
        '1': '建筑建材',
        '2': '通用工业',
        '3': '绿色生活',
        '4': '其他'
      }

      if (this.viewers.length > 0) {
        const filteredViewers = this.visibleViewers

        // 按行业分组
        const groups = {}
        filteredViewers.forEach(viewer => {
          const industryKey = viewer.industry || '4' // 默认为其他
          if (!groups[industryKey]) {
            groups[industryKey] = []
          }
          groups[industryKey].push(viewer)
        })

        // 对每个分组内的模型按sort字段排序
        Object.keys(groups).forEach(industryKey => {
          groups[industryKey].sort((a, b) => {
            const sortA = a.sort || 0
            const sortB = b.sort || 0
            return sortA - sortB
          })
        })

        // 转换为数组格式，包含分组标题
        return Object.keys(groups).map(industryKey => ({
          title: industryMap[industryKey] || '其他',
          industryKey: industryKey,
          models: groups[industryKey]
        }))
      } else {
        return []
      }
    },
    filteredViewers() {
      if (this.viewers.length > 0) {
        return this.visibleViewers.slice().sort(function (a, b) {
          // 首先按sort字段升序排列
          if (a.sort !== undefined && b.sort !== undefined) {
            if (a.sort < b.sort) return -1
            if (a.sort > b.sort) return 1
          }
          // 如果sort字段相同或不存在，则按行业名称排序
          let x = a.industry.toLowerCase()
          let y = b.industry.toLowerCase()
          if (x < y) {
            return -1
          }
          if (x > y) {
            return 1
          }
          return 0
        })
      } else {
        return []
      }
    },
    currentViewer() {
      return this.viewers.filter(
        (viewer) => viewer.viewerId == this.viewerId
      )[0]
    },
    isViewer() {
      return !(
        this.viewerId == '' ||
        this.viewerId == null ||
        !this.currentViewer
      )
    },
    emersyaId() {
      return this.isViewer ? this.currentViewer.emersyaId : ''
    },
    projectCode() {
      return this.isViewer ? this.currentViewer.projectCode : ''
    },
    topBarHeight() {
      return this.mobileLayout ? '36' : '0'
    },
    isAnyMobileBottomMenuOpen() {
      return this.displayMobileBottomModels || this.displayMobileBottomColors
    },
    bottomBarHeight() {
      if (this.mobileLayout) {
        let height = this.$refs.mobileBottomSelectMenu.clientHeight
        if (this.isAnyMobileBottomMenuOpen) {
          height += 90
        }
        return height
      }
      return this.displayBottomModels ? '120' : '7'
    },
    link() {
      return window.location.href
    },
    // 基础过滤后的查看器列表（根据viewerId规则过滤）
    baseFilteredViewers() {
      if (this.viewers.length === 0) {
        return []
      }
      
      // 根据viewerId决定过滤规则
      if (this.viewerId === '0' || this.viewerId === '' || this.viewerId == null) {
        // viewerId为0时，只展示status='1'的数据
        return this.viewers.filter((viewer) => viewer.status == '1')
      } else {
        // viewerId不为0时，查找对应的modelOwnership，展示相同modelOwnership的所有数据
        const currentViewer = this.viewers.find(viewer => viewer.viewerId == this.viewerId)
        if (currentViewer && currentViewer.modelOwnership) {
          return this.viewers.filter((viewer) => viewer.modelOwnership === currentViewer.modelOwnership)
        } else {
          // 如果找不到对应的viewer或modelOwnership为空，回退到原逻辑
          return this.viewers.filter((viewer) => viewer.status == '1')
        }
      }
    },
    // 移动端过滤后的模型列表
    filteredMobileModels() {
      let filteredViewers = [...this.visibleViewers]

      // 如果选择了特定行业，进行过滤
      if (this.selectedMobileIndustry !== 'all') {
        filteredViewers = filteredViewers.filter((viewer) => {
          const viewerIndustry = viewer.industry || '4'
          return viewerIndustry === this.selectedMobileIndustry
        })
      }

      // 按sort字段排序
      return filteredViewers.sort((a, b) => {
        const sortA = a.sort || 0
        const sortB = b.sort || 0
        return sortA - sortB
      })
    },
    materialBallViewer() {
      return getColorTrendsMaterialBallViewer(this.baseFilteredViewers)
    },
    visibleViewers() {
      return getColorTrendsListViewers(this.baseFilteredViewers)
    },
    colorTrendsCategories() {
      const configurations = []
      Object.keys(this.materialGroups || {}).forEach((groupName) => {
        Object.keys(this.materialGroups[groupName] || {}).forEach((configurationName) => {
          configurations.push({
            groupName,
            configurationName,
            key: getColorTrendsMaterialImageKey(configurationName)
          })
        })
      })

      return colorTrendsMaterialCatalog.map((category) => ({
        name: category.name,
        materials: category.materials.map((material) => {
          const configuration = configurations.find((item) => item.key === material.key)
          return configuration
            ? Object.assign({}, material, configuration)
            : null
        }).filter(Boolean)
      }))
    }
  },
  watch: {
    industryGroups: {
      handler(newGroups) {
        if (newGroups.length > 0) {
          this.expandedGroups = new Array(newGroups.length).fill(true); // 默认所有分组都展开
        }
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.brandId = this.$route.query.brandId
    this.viewerId = this.$route.query.viewerId
    this.type = this.$route.query.type

    this.presetConfigurationName = this.$route.query.configurationName
      ? decodeURI(this.$route.query.configurationName).split(',')
      : []
    this.presetGroupName = this.$route.query.groupName
      ? decodeURI(this.$route.query.groupName).split(',')
      : []

    emersyaLogin().then(({ data }) => {
      if (data && data.code === 0) {
        console.log(data)
        this.emersyaSessionId = data.sessionId
      }
    })
  },
  beforeDestroy() {
    console.log("组件即将销毁，清理定时器");
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)

    emersyaLogout({
      sessionId: this.emersyaSessionId
    }).then(({ data }) => {
      if (data && data.code === 0) {
        console.log(data)
        this.emersyaSessionId = ''
      }
    })
  },
  created() {
    this.parseUrlParams();
    let currentUrl = window.location.href;
    console.log('当前页面的URL:', currentUrl);
    // let currentUrl = 'https://www.colorkite.com.cn/#/modelViewerScreen?brandId=dcf7bb23ebeb4509ac6905c6d29b24e6&mobile=13913710123';
    // 找到URL中"?"符号的位置
    const queryStringStart = currentUrl.indexOf('?');

    // 如果存在查询字符串，则截取查询字符串部分
    let queryString = '';
    if (queryStringStart !== -1) {
      queryString = currentUrl.substring(queryStringStart);
    }

    // 解析查询参数
    const url = new URLSearchParams(queryString);
    this.mobile = url.get('mobile');
    this.userName = url.get('userName');
    this.companyName = url.get('companyName');
    this.urlFrom = url.get('from');
    console.log('mobile参数的值:', this.mobile);

    // 将参数保存到localStorage
    if (this.mobile) {
      localStorage.setItem('mobile', this.mobile);
    }
    if (this.userName) {
      localStorage.setItem('userName', this.userName);
    }
    if (this.companyName) {
      localStorage.setItem('companyName', this.companyName);
    }
    if (this.urlFrom) {
      localStorage.setItem('urlFrom', this.urlFrom);
    }
    document.title = '在线渲染'
    this.getBrandLogo()
    this.getViewerInfo()

    document.addEventListener(
      'emersyaViewerInitialized',
      this.initViewer,
      false
    )

    // 初始化分组展开状态
    this.$nextTick(() => {
      this.expandedGroups = new Array(this.industryGroups.length).fill(true); // 默认所有分组都展开
    })
  },
  methods: {
    viewerTitle(title) {
      return getViewerTitle(title)
    },

    // 页面刷新方法 - 每30分钟自动刷新一次页面
    refreshPage() {
      window.location.reload();
    },

    // 初始化3D查看器
    async initViewer() {
      // 等待 emersyaSessionId 就绪，避免空 sessionId 导致材质组请求失败
      if (!this.emersyaSessionId) {
        try {
          await new Promise((resolve, reject) => {
            const unwatch = this.$watch('emersyaSessionId', (val) => {
              if (val) {
                unwatch()
                resolve()
              }
            })
            // 10 秒超时，避免无限等待
            setTimeout(() => {
              unwatch()
              reject(new Error('获取 emersyaSessionId 超时'))
            }, 10000)
          })
        } catch (e) {
          console.warn('emersyaSessionId 未就绪，继续执行', e)
        }
      }
      this.startTimer() // 启动定时器
      this.addClick(this.viewerId) // 记录点击
      this.addAccessLog(this.viewerId) // 记录访问日志

      // 计算查看器高度
      this.viewerHeight = window.innerHeight - this.topBarHeight - this.bottomBarHeight + 'px'
      this.hasInitiatedViewer = true
      this.viewerActive = true

      // 获取所有材质组
      this.getAllMaterialGroups()

      // 安全检测 emViewers 全局对象
      if (typeof emViewers === 'undefined' || !emViewers['emersyaMainViewer']) {
        console.error('emersya 查看器尚未就绪，initViewer 终止')
        return
      }
      window.emersyaViewer = emViewers['emersyaMainViewer']

      // 添加全局事件监听器
      emViewers['emersyaMainViewer'].addEventListener('onStateChange', (data) => {
        if (data.viewerState == 'loaded') {
          this.getIsArAvailable() // 检查AR可用性

          // 如果有预设配置，应用预设
          if (this.presetConfigurationName.length > 0 && this.presetGroupName.length > 0) {
            this.presetConfigurationName.forEach((item, index) => {
              this.selectMaterial(
                this.presetGroupName[index],
                this.presetConfigurationName[index]
              )
            })
          } else {
            // 否则获取默认材质组
            console.log('Getting current material groups')
            this.getCurrentMaterialGroups()
          }
        }
      })

      // 监听材质高亮事件
      emViewers['emersyaMainViewer'].addEventListener('onConfigurableMaterialHighlight', (data) => {
        let material = data.length > 0 ? data[0] : ''
        emViewers['emersyaMainViewer'].setHighlight({
          meshes: [],
          configurableMaterials: [material],
          configurableMaterialGroups: []
        })
        this.resetTimer()
      }, false)

      // 监听模型选择事件
      emViewers['emersyaMainViewer'].addEventListener('onMeshSelection', (data) => {
        console.log(data)
        if (data.configurableMaterialsGroupName[0]) {
          this.selectedGroup = data.configurableMaterialsGroupName[0]
          console.log(this.selectedGroup)
        } else {
          console.log('Selected non-configurable')
        }
      }, false)
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.$refs.mobileBottomSelectMenu) {
        console.log(this.bottomBarHeight, 'height')
      }
      // 重新计算查看器高度
      this.viewerHeight = window.innerHeight - this.topBarHeight - this.bottomBarHeight + 'px'
      // 判断是否为移动端布局
      this.mobileLayout = window.innerWidth <= 818
    },

    // 获取品牌Logo
    getBrandLogo() {
      this.$nextTick(() => {
        getBrandLogoApi({ brandId: this.brandId }).then(({ data }) => {
          if (data && data.code === 0) {
            this.brandLogoURL = data.logoPath
          }
        })
      })
    },

    parseUrlParams() {
      const url = new URL(window.location.href);
      this.viewerId = url.searchParams.get('viewerId');
      this.brandId = url.searchParams.get('brandId');
      // 其他参数...
    },
    // 获取查看器信息
    getViewerInfo() {
      this.$nextTick(() => {
        getViewerInfoApi({viewerId: this.viewerId || '0', brandId: this.brandId }).then(({ data }) => {
          if (data && data.code === 0) {
            this.viewers = filterColorTrendsViewers(data.viewers)
            if (this.viewerId && this.currentViewer) {
              this.showViewer(this.currentViewer)
            }
          }
        })
      })
    },

    // 记录点击事件
    addClick(viewerId) {
      this.$nextTick(() => {
        addClick({ viewerId: viewerId }).then(({ data }) => {
          if (data && data.code === 0) {
            // 点击记录成功
          } else {
            console.log('Error recording click')
          }
        })
      })
    },

    // 记录访问日志
    addAccessLog(viewerId) {
      var mobile = Cookies.get('mobile')
      var phone = localStorage.getItem('mobile');
      var userName = localStorage.getItem('userName');
      var companyName = localStorage.getItem('companyName');
      var urlFrom = localStorage.getItem('urlFrom');
      if (phone === null) {
        phone = mobile
      }
      var params = {
        viewerId: viewerId,
        mobile: phone,
        userName: userName,
        companyName: companyName,
        urlFrom: urlFrom
      }
      this.$nextTick(() => {
        addAccessLog(params).then(({ data }) => {
          if (data && data.code === 0) {
            // 访问记录成功
          } else {
            console.log('Error recording click')
          }
        })
      })
    },

    // 显示选中的模型
    showViewer(model, isManualChange) {
      console.log('showViewer', model, isManualChange)
      this.hasInitiatedViewer = false
      this.previousViewerId = this.viewerId

      // 缓存当前材质信息
      if (this.selectedGroup && this.currentMaterials[this.selectedGroup]) {
        this.cachedModels.push({
          routingCode: this.emersyaId,
          selectedGroup: this.selectedGroup,
          currentMaterials: this.currentMaterials,
          materialGroups: this.materialGroups
        })
      }

      this.viewerId = model.viewerId
      this.expandedColorTrendsCategories = {}
      if (isManualChange) {
        this.presetConfigurationName = ''
        this.presetGroupName = ''
        this.selectedGroup = ''
        this.updateURL()
        this.$forceUpdate()
      }

      // 检查是否有缓存的模型信息
      let similarChachedModels = this.cachedModels.filter(
        (obj) => obj.routingCode == this.emersyaId
      )
      if (similarChachedModels.length > 0) {
        const latestCachedModel = similarChachedModels[similarChachedModels.length - 1]
        console.log(similarChachedModels, 'HAS BEEN LOADED BEFORE!')
        this.currentMaterials = latestCachedModel.currentMaterials
        // 防止空对象导致 selectedGroup 为 undefined
        const materialKeys = Object.keys(this.currentMaterials)
        this.selectedGroup = materialKeys.length > 0 ? materialKeys[0] : ''
        this.materialGroups = latestCachedModel.materialGroups
      }
      this.switchViewer(this.emersyaId)
      this.resetTimer()
    },

    // 隐蔽入口：打开列表中隐藏的首个材质球模型
    openMaterialBallViewer() {
      const materialBallViewer = this.materialBallViewer ||
        getColorTrendsMaterialBallViewer(this.viewers)
      if (materialBallViewer) {
        this.showViewer(materialBallViewer, true)
      }
    },

    // 切换查看器
    switchViewer(routingCode) {
      // 移除现有的Emersya脚本
      const existingEmersyaScript = document.getElementById('emersya')
      if (existingEmersyaScript) {
        existingEmersyaScript.remove()
      }

      // 创建新的Emersya脚本
      const emersyaScript = document.createElement('script')
      emersyaScript.setAttribute('src', 'https://cdn.emersya.com/f/emersyaLoader.js')
      emersyaScript.setAttribute('type', 'text/javascript')
      emersyaScript.setAttribute('id', 'emersya')
      emersyaScript.setAttribute('routing', routingCode)
      emersyaScript.setAttribute('containerId', 'emersyaMainViewer')
      document.head.appendChild(emersyaScript)
    },

    // 返回模型选择菜单
    backToMenu() {
      this.viewerId = ''
      this.currentProductNo = ''
      this.currentProductInfo = {
        productCategory: '',
        surface: '',
        gloss: '',
        productPerformance: '',
        hex: ''
      }
      this.hasInitiatedViewer = false
      this.currentMaterials = []
      this.materialGroups = []
      this.updateURL()
      this.resetTimer()
    },

    // 获取所有材质组
    getAllMaterialGroups() {
      this.$nextTick(() => {
        getAllMaterialGroupsApi({
          sessionId: this.emersyaSessionId,
          projectCode: this.projectCode
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.materialGroups = data.materialGroups
            this.getProductInfoList()

            if (this.mobileLayout && this.selectedGroup == '') {
              this.selectedGroup = Object.keys(data.materialGroups)[0]
            }
          }
        })
      })
    },

    // 获取产品信息列表
    getProductInfoList() {
      let productNos = []
      let productNoSet = new Set()
      Object.keys(this.materialGroups).forEach((item) => {
        Object.keys(this.materialGroups[item]).forEach((product) => {
          let productNo = this.extractFirst8Digits(product)
          if (productNo && productNo.length > 2 && !productNoSet.has(productNo)) {
            productNoSet.add(productNo)
            productNos.push(productNo)
          }
        })
      })
      console.log('productNos', productNos)
      if (productNos.length === 0) {
        console.log('无可获取的产品编号，跳过查询')
        return
      }
      if (!this.brandId) {
        console.log('品牌 ID 为空，跳过产品信息查询')
        return
      }
      this.$nextTick(() => {
        getProductInfoBulkApi({
          productNoList: productNos,
          brandId: this.brandId
        }).then(({ data }) => {
          if (!data) {
            console.log('产品信息查询接口无响应')
            return
          }
          if (data.code == 'C0' || data.code === 0) {
            this.cachedProductList = {}
            ;(data.viewer || []).forEach((item) => {
              const key = this.extractFirst8Digits(item.productNo)
              if (key && key.length > 2) {
                this.cachedProductList[key] = item
              }
            })
            console.log('获取到的产品数据：', this.cachedProductList)
          } else {
            // 后端返回非成功 code（如 C1），为系统级错误，前台不做额外处理
            console.log('产品信息查询非预期响应:', data.code)
          }
        }).catch((err) => {
          console.log('产品信息查询请求异常:', err)
        })
      })
    },

    // 选择材质
    selectMaterial(groupName, configurationName) {
      console.log("------------------------点击选色", groupName, configurationName)
      // 安全检测 emViewers
      if (typeof emViewers === 'undefined' || !emViewers['emersyaMainViewer']) {
        console.error('emersya 查看器未就绪，无法选色')
        return
      }
      emViewers['emersyaMainViewer'].setMaterialsGroup({
        configurationName: configurationName,
        groupName: groupName
      })
      this.currentMaterials[groupName] = configurationName
      this.currentProductNo = this.extractFirst8Digits(configurationName)
      this.selectedGroup = groupName
      this.getProductInfo()
      this.updateURL()
      this.$forceUpdate()
      this.resetTimer()
    },

    // 获取当前材质组
    getCurrentMaterialGroups() {
      if (typeof emViewers === 'undefined' || !emViewers['emersyaMainViewer']) {
        console.warn('emersya 查看器未就绪，无法获取当前材质组')
        return
      }
      emViewers['emersyaMainViewer']
        .getCurrentMaterialsGroup()
        .then((data) => {
          console.log(data, 'currentmaterialgroups')
          this.currentMaterials = []
          data.forEach((element) => {
            this.currentMaterials[element.groupName] = element.configurationName
          })
        })
        .error(function (error) {
          console.log(error)
        })
    },

    // 点击材质组
    clickedGroup(index, isMobile) {
      if (this.selectedGroup == index && !isMobile) {
        this.selectedGroup = ''
      } else {
        this.selectedGroup = index
      }
    },

    // 切换分组展开/收起
    toggleGroup(index) {
      this.expandedGroups[index] = !this.expandedGroups[index];
    },

    // 更新URL参数
    updateURL() {
      this.$router.replace({
        query: {
          brandId: this.brandId,
          viewerId: this.viewerId,
          groupName: Object.keys(this.currentMaterials).toString(),
          configurationName: Object.values(this.currentMaterials).toString()
        }
      })
    },

    // 检查AR是否可用
    getIsArAvailable() {
      if (typeof emViewers === 'undefined' || !emViewers['emersyaMainViewer']) {
        console.warn('emersya 查看器未就绪，无法检查AR')
        return
      }
      emViewers['emersyaMainViewer']
        .getARAvailability()
        .then((data) => (this.isArAvailable = data))
        .error(function (error) {
          console.log(error)
        })
    },

    // 启动AR功能
    startAr() {
      if (typeof emViewers === 'undefined' || !emViewers['emersyaMainViewer']) {
        console.warn('emersya 查看器未就绪，无法启动AR')
        return
      }
      emViewers['emersyaMainViewer'].startAr()
    },

    // 提取字符串中的前8位数字
    extractFirst8Digits(str) {
      let count = 0
      let result = ''
      for (let i = 0; i < str.length; i++) {
        if (!isNaN(parseInt(str[i]))) {
          result += str[i]
          count++
          if (count === 8) {
            break
          }
        }
      }
      return result
    },

    getMaterialImage(materialName) {
      return colorTrendsMaterialImages[getColorTrendsMaterialImageKey(materialName)] || ''
    },

    // 获取产品信息
    getProductInfo() {
      this.currentProductInfo = this.cachedProductList[this.currentProductNo]
        ? this.cachedProductList[this.currentProductNo]
        : {}
    },

    // 下载图片
    downloadImage() {
      const processScreenshot = this.processScreenshot
      emViewers['emersyaMainViewer']
        .getScreenshot({
          width: 512,
          height: 512,
          transparentBackground: false
        })
        .then((data) => processScreenshot(data))
        .error(function (error) {
          console.log(error)
        })
    },

    // 处理截图
    processScreenshot(screenshot) {
      const a = document.createElement('a')
      a.href = `data:${screenshot}`
      a.download = `${this.currentViewer.viewerTitle}.png`
      document.body.appendChild(a)
      a.click()
    },

    // 切换底部模型栏显示
    toggleBottomBarModelsDisplay() {
      this.displayBottomModels = !this.displayBottomModels
      this.handleResize()
      emViewers['emersyaMainViewer'].resize()
      this.resetTimer()
    },

    // 切换移动端底部模型栏显示
    toggleMobileBottomBarModelsDisplay() {
      this.displayMobileBottomModels = !this.displayMobileBottomModels
      if (this.displayMobileBottomModels) {
        if (this.displayMobileBottomColors) {
          this.displayMobileBottomColors = false
        }
        this.$refs.mobileBottomSelectMenu.style.bottom = '90px'
      } else {
        this.$refs.mobileBottomSelectMenu.style.bottom = '0px'
      }
      this.handleResize()
      emViewers['emersyaMainViewer'].resize()
      this.resetTimer()
    },

    // 切换移动端底部颜色栏显示
    toggleMobileBottomBarColorsDisplay() {
      this.resetTimer()
      this.displayMobileBottomColors = !this.displayMobileBottomColors
      if (this.displayMobileBottomColors) {
        if (this.displayMobileBottomModels) {
          this.displayMobileBottomModels = false
          this.$refs.mobileBottomSelectMenu.style.bottom = '0px'
        }
      }
      this.handleResize()
      emViewers['emersyaMainViewer'].resize()
    },

    // 切换自定义面板显示
    toggleCustomizeDisplay() {
      this.displayCustomize = !this.displayCustomize
      this.$nextTick(() => {
        this.handleResize()
        if (typeof emViewers !== 'undefined' && emViewers['emersyaMainViewer']) {
          emViewers['emersyaMainViewer'].resize()
        }
      })
      this.resetTimer()
    },

    // 复制链接
    copyLink() {
      navigator.clipboard.writeText(this.link)
      this.$message({
        message: this.$t('copy_success'),
        type: 'success',
        duration: 1500
      })
    },

    // 启动定时器
    startTimer() {
      const timerLength = 1000 * 60 * 30 // 30分钟
      this.timer = setInterval(() => {
        location.reload()
      }, timerLength)
    },

    // 重置定时器
    resetTimer() {
      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
        this.startTimer()
      }
    },

    // 移动端行业选择变化处理
    onMobileIndustryChange(value) {
      this.selectedMobileIndustry = value
      // 可以在这里添加其他逻辑，比如滚动到顶部等
    },

    toggleColorTrendsCategory(categoryName) {
      this.expandedColorTrendsCategories = toggleColorTrendsCategoryState(
        this.expandedColorTrendsCategories,
        categoryName
      )
    }
  }
}
</script>

<style lang="scss">
.spacer {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  position: relative;
  background-image: url('../../assets/img/tigerh.png');
  background-repeat: no-repeat;
  background-position: right calc(50% + 90px);
  background-size: auto 100%;
}

/* 移动端背景图片尺寸调整 */
@media (max-width: 818px) {
  .spacer {
    background-size: auto 60%;
    /* 移动端背景图片缩小40% */
  }

  /* 移动端模型选择器容器调整 */
  .modelSelector {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 只在模型选择页面应用居中样式 */
  .spacer .modelSelector {
    /* 当存在modelSelector时，应用父容器居中样式 */
  }

  .spacer .modelSelector~* {
    /* 清除后续元素可能的影响 */
  }
}

/* 移动端模型选择页面居中样式 */
@media (max-width: 818px) {
  .spacer .modelSelector {
    /* 当存在modelSelector时，触发父容器样式 */
  }

  .spacer:has(.modelSelector) {
    display: flex;
    align-items: center;
    /* 垂直居中 */
    justify-content: center;
    /* 水平居中 */
    min-height: 100vh;
    /* 确保占满视口高度 */
  }

  .glass-overlay:has(.modelSelector) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;

    /* 移动端内容容器 */
    >div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 600px;
      padding: 20px;
      box-sizing: border-box;
    }
  }

  /* 确保移动端内容在小屏幕上正确显示 */
  @media (max-height: 600px) {
    .glass-overlay:has(.modelSelector) {
      align-items: flex-start;
      padding-top: 20px;
    }
  }
}

/* 移动端模型查看器页面样式重置 */
@media (max-width: 818px) {
  .modelViewer {
    /* 确保模型查看器占满整个屏幕，但不覆盖底部控件 */
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 99 !important;
    /* 降低z-index，让底部菜单显示在上面 */
    background: white;
  }

  /* 模型查看器内的3D容器 */
  .modelViewer #emersyaMainViewer {
    width: 100% !important;
    height: calc(100vh - 35px - 150px) !important;
    /* 减去顶部菜单和底部控件高度（预留更多空间） */
    margin-top: 35px !important;
  }

  /* 移动端顶部菜单 */
  .modelViewer .mobileTopMenu {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    z-index: 1000 !important;
  }

  /* 移动端底部模型选择菜单 */
  .mobileBottomSelectMenu {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100% !important;
    z-index: 1001 !important;
    /* 确保在模型查看器之上 */
    background-color: rgba(255, 255, 255, 0.95) !important;
    /* 白色半透明背景 */
    backdrop-filter: blur(10px);
    /* 毛玻璃效果 */
  }

  /* 移动端模型选择菜单容器 */
  .modelSelectMenu {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100% !important;
    z-index: 1001 !important;
  }

  /* 确保底部菜单内容背景清晰 */
  .mobileBottomSelectMenu .menuSegment .colorsContent,
  .mobileBottomSelectMenu .menuSegment .modelsContent {
    background-color: #fff !important;
  }

  /* 移动端底部菜单重新布局 */
  .mobileBottomSelectMenu {
    display: flex !important;
    flex-direction: column !important;
  }

  .mobileBottomSelectMenu .colorMenuSegment {
    order: 1;
    /* 颜色菜单在上方 */
  }

  .mobileBottomSelectMenu .modelMenuSegment {
    order: 2;
    /* 模型菜单在下方 */
  }

  /* 内容容器向上展开 */
  .mobileBottomSelectMenu .menuSegment {
    position: relative;
  }

  /* 颜色选择内容向上展开 */
  .mobileBottomSelectMenu .menuSegment .colorsContent {
    position: absolute !important;
    bottom: 100% !important;
    /* 在整个菜单段上方显示 */
    left: 0 !important;
    right: 0 !important;
    margin-bottom: 0 !important;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15) !important;
    /* 向上的阴影 */
    border-radius: 8px 8px 0 0 !important;
    /* 顶部圆角 */
  }

  /* 模型选择内容向上展开 */
  .mobileBottomSelectMenu .menuSegment .modelsContent {
    position: absolute !important;
    bottom: 100% !important;
    /* 在整个菜单段上方显示 */
    left: 0 !important;
    right: 0 !important;
    margin-top: 0 !important;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15) !important;
    /* 向上的阴影 */
    border-radius: 8px 8px 0 0 !important;
    /* 顶部圆角 */
  }

  /* 重置模型查看器页面的容器样式 */
  .spacer:has(.modelViewer) {
    display: block !important;
    align-items: unset !important;
    justify-content: unset !important;
    min-height: 100vh;
  }

  .glass-overlay:has(.modelViewer) {
    display: block !important;
    align-items: unset !important;
    justify-content: unset !important;
    min-height: 100vh;

    >div {
      display: block !important;
      flex-direction: unset !important;
      align-items: unset !important;
      justify-content: unset !important;
      width: 100% !important;
      max-width: unset !important;
      padding: 0 !important;
      box-sizing: border-box;
    }
  }

  /* 中等移动屏幕调整 */
  @media (max-width: 640px) and (min-width: 481px) {
    .mobileModelGrid {
      width: 353px;
      /* 与选择框宽度保持一致 */
      max-width: 100%;
      /* 确保不超出容器 */
      padding: 0 15px;
      gap: 15px;
      /* 中等屏幕适中的间隙 */
    }

    .mobileIndustrySelector .el-select {
      width: 353px !important;
      /* 与默认移动端保持一致 */
      max-width: 100%;
      /* 确保不超出容器 */
    }
  }

  /* 超小屏幕调整 */
  @media (max-width: 480px) {
    .mobileModelGrid {
      grid-template-columns: repeat(2, minmax(120px, 1fr));
      /* 小屏幕改为两列 */
      gap: 14px;
      /* 小屏幕也增加间隙 */
      padding: 0 20px;
      justify-content: center;
      margin: 0 auto;
      width: 353px;
      /* 与选择框宽度保持一致 */
      max-width: 100%;
      /* 确保不超出容器 */
    }

    .mobileIndustrySelector .el-select {
      width: 353px !important;
      /* 与默认移动端保持一致 */
      max-width: 100%;
      /* 确保不超出容器 */
      margin: 0 auto;
    }
  }
}

.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  /* 进一步降低透明度，让背景图更清楚 */
  backdrop-filter: blur(1);
  /* 进一步减少模糊程度 */
  -webkit-backdrop-filter: blur(1);
  /* Safari 兼容 */
  z-index: 1;
  /* 确保在背景图之上 */
}

.noData {
  padding: 50px;
  font-size: 40px;
  text-align: center;
}

.brandLogoSelector {
  width: 280px;
  height: 85px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  color: white;
  font-size: 50px;
  text-align: center;
  margin-top: 4%;

  /* 移动端调整 */
  @media (max-width: 818px) {
    margin-top: 0;
    margin-bottom: 30px;
    width: 240px;
    height: 72px;
  }
}

.yituLogo {
  position: fixed;
  left: 50px;
  bottom: 60px;
  z-index: 10;
}

.yituLogoMobile {
  position: fixed;
  left: 10px;
  bottom: 110px;
  z-index: 10;
}

.industrySelectorArea {
  width: fit-content;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4%;
  cursor: pointer;

  .industrySelector {
    display: flex;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 4px 4px 10px #c0c0c0;
    border-radius: 15px;

    div {
      padding: 10px 20px 10px 20px;
      border: 1px solid #c0c0c0;
    }

    div:nth-child(-n + 1) {
      border-radius: 15px 0px 0px 15px;
    }

    div:last-child {
      border-radius: 0px 15px 15px 0px;
    }
  }
}

.selectedIndustry {
  background-color: #97c11c;
  color: #ffffff;
}

.modelNameTrigger {
  width: 420px;
  max-width: calc(100vw - 120px);
  min-height: 40px;
  margin: 12px 20px;
  padding: 8px 14px;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  color: #97c11c;
  font-size: 21px;
  font-weight: bold;
  line-height: 22px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;

  &:hover {
    background: transparent;
    color: #97c11c;
    opacity: 0.82;
  }

  &:focus {
    outline: 2px solid rgba(151, 193, 28, 0.7);
    outline-offset: 2px;
  }

  &:active {
    opacity: 0.65;
  }
}

@media (max-width: 818px) {
  .mobileTopMenu .modelNameTrigger {
    max-width: calc(100vw - 75px);
    min-height: 35px;
    margin: 0;
    padding: 4px 8px;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    color: #97c11c;
    font-size: 21px;
    font-weight: bold;
  }
}

@media (prefers-reduced-motion: reduce) {
  .modelNameTrigger {
    transition: none;
  }
}

.unselectedIndustry {
  color: #000000;
  background-color: white;
}

.modelSelectionArea {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  padding: 30px;
  display: flex;
  flex-direction: column;

  .modelGroup {
    margin-bottom: 30px;
    display: flex;
    align-items: stretch;
    /* 确保高度一致以实现分割线对齐 */
    min-height: 160px;

    .groupHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
      min-width: 373px;
      max-width: 427px;
      margin-right: 25px;
      flex-shrink: 0;
      height: 160px;
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      cursor: pointer;
      border: 2px solid #97c11c;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -15px;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #e0e0e0 0%, #97c11c 50%, #e0e0e0 100%);
        overflow: hidden;
        z-index: 1;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent 0%, #97c11c 50%, transparent 100%);
          animation: separatorFlow 3s ease-in-out infinite;
        }
      }

      &:hover {
        background: #97c11c;
        box-shadow: 0 4px 12px rgba(151, 193, 28, 0.3);
        transform: translateY(-2px);

        .groupTitleText {
          color: #fff;
        }

        .groupArrow {
          background: #fff;
          color: #97c11c;
        }
      }
    }

    .groupTitleBox {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      border-radius: 0;
      padding: 0;
      margin-bottom: 0;
      flex: 1;
      justify-content: flex-start;
    }

    .groupTitleText {
      font-size: 18px;
      font-weight: bold;
      color: #97c11c;
      margin-right: 0;
      text-align: left;
      transition: color 0.3s ease;
    }

    .groupArrow {
      background: #97c11c;
      color: #fff;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      transition: all 0.3s ease;
      flex-shrink: 0;
    }

    .groupArrow.expanded {
      transform: rotate(0deg);
    }

    .modelCardsContainer {
      display: flex;
      flex-wrap: nowrap;
      gap: 15px;
      flex: 1;
      min-width: 400px;
      position: relative;
      overflow-x: auto;
      overflow-y: visible;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 20px;

      /* 隐藏滚动条但保持功能 */
      &::-webkit-scrollbar {
        height: 0;
        width: 0;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 6px;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #e0e0e0 0%, #97c11c 50%, #e0e0e0 100%);
        overflow: hidden;
        z-index: 1;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent 0%, #97c11c 50%, transparent 100%);
          animation: separatorFlow 3s ease-in-out infinite;
        }
      }
    }

    .groupSeparator {
      height: 2px;
      background: linear-gradient(90deg, #e0e0e0 0%, #97c11c 50%, #e0e0e0 100%);
      margin: 20px 0;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent 0%, #97c11c 50%, transparent 100%);
        animation: separatorFlow 3s ease-in-out infinite;
      }
    }
  }

  .modelSelectCard {
    height: 160px;
    width: 160px;
    min-width: 160px;
    flex-shrink: 0;
    border-radius: 8px;
    cursor: pointer;
    opacity: 1;
    background: #fff;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    padding: 0;

    &::before {
      display: none;
    }

    .modelTitle {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
      color: #fff;
      text-shadow: none;
      background: #97c11c;
      padding: 8px 12px;
      z-index: 2;
    }

    .modelSelectImage {
      display: block;
      width: 70%;
      height: calc(100% - 50px);
      border-radius: 8px 8px 0 0;
      box-shadow: none;
      transition: transform 0.3s ease;
      position: relative;
      z-index: 1;
      object-fit: cover;
      object-position: center top;
      margin: 0 auto;
      margin-top: 10px;
    }
  }

  .modelSelectCard:hover {
    opacity: 1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: #f8f9fa;

    .modelSelectImage {
      transform: scale(1.02);
    }
  }
}

.mobileModelSelector {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 确保子元素居中 */

  /* 移动端垂直居中调整 */
  @media (max-width: 818px) {
    max-width: 600px;
    /* 限制最大宽度 */
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .mobileIndustrySelector {
    margin-bottom: 25px;
    text-align: center;

    /* 移动端对齐调整 */
    @media (max-width: 818px) {
      padding: 0 12px;
      /* 与mobileModelGrid的padding保持一致 */
    }

    @media (max-width: 640px) and (min-width: 481px) {
      padding: 0 15px;
      /* 与中等屏幕网格padding保持一致 */
    }

    @media (max-width: 480px) {
      padding: 0 20px;
      /* 与小屏幕网格padding保持一致 */
    }

    .el-select {
      width: 370px;

      /* 移动端自适应宽度 - 与模型网格宽度保持一致 */
      @media (max-width: 818px) {
        width: 353px !important;
        /* 强制设置宽度：476px + 60px = 536px */
        max-width: 100%;
        /* 确保不超出容器 */
        margin: 0 auto;
        padding-left: 12px;
      }

      .el-input__inner {
        border-radius: 8px;
        border: 2px solid #97c11c;
        color: #333;
        font-weight: 600;
        text-align: center;
        height: 48px;
        font-size: 16px;
        background: #fff;
        box-shadow: 0 2px 8px rgba(151, 193, 28, 0.15);
        transition: all 0.3s ease;

        &:focus {
          border-color: #799a17;
          box-shadow: 0 4px 12px rgba(151, 193, 28, 0.25);
        }
      }

      .el-input__suffix {
        color: #97c11c;
        font-size: 18px;
      }

      &:hover .el-input__inner {
        border-color: #799a17;
        box-shadow: 0 3px 10px rgba(151, 193, 28, 0.2);
      }
    }
  }

  .mobileModelGrid {
    display: grid;
    grid-template-columns: repeat(3, minmax(100px, 1fr));
    gap: 16px;
    /* 增加间隙让模型卡片之间有更明显的分离 */
    padding: 8px 12px;
    /* 增加上下内边距，进一步增强分离感 */
    justify-content: center;
    width: 353px;
    /* 与选择框宽度保持一致 */
    max-width: 100%;
    /* 确保不超出容器 */
    margin: 0 auto;

    .modelSelectCard {
      height: 120px;
      min-width: 115px;
      border-radius: 8px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #f0f0f0;
      /* 添加淡边框增强分离感 */
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      padding: 0;

      &::before {
        display: none;
      }

      .modelTitle {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0;
        font-size: 11px;
        text-align: center;
        font-weight: 600;
        color: #fff;
        text-shadow: none;
        background: #97c11c;
        padding: 6px 4px;
        z-index: 2;
        line-height: 1.2;
      }

      .modelSelectImage {
        display: block;
        width: 100%;
        height: calc(100% - 32px);
        border-radius: 8px 8px 0 0;
        box-shadow: none;
        transition: transform 0.3s ease;
        position: relative;
        z-index: 1;
        object-fit: cover;
        object-position: center top;
        margin: 0;
      }
    }

    .modelSelectCard:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(151, 193, 28, 0.15);
      border-color: #97c11c;
      /* 悬停时突出边框 */

      .modelSelectImage {
        transform: scale(1.03);
      }
    }
  }
}

.modelSelectionAreaMobile {
  width: 94%;
  margin-left: 3%;
  margin-right: 3%;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;

  /* 移动端垂直居中调整 */
  @media (max-width: 818px) {
    width: 100%;
    margin: 0;
    padding: 20px;
    box-sizing: border-box;
    max-width: 600px;
    /* 限制最大宽度 */
  }

  .modelGroup {
    margin-bottom: 20px;
    display: block;

    .groupHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding: 15px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 2px solid #97c11c;
      transition: all 0.3s ease;
      cursor: pointer;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 100%;
        height: 2px;
        background-color: #e0e0e0;
      }

      &:hover {
        background: #97c11c;
        box-shadow: 0 4px 12px rgba(151, 193, 28, 0.3);
        transform: translateY(-1px);

        .groupTitleText {
          color: #fff;
        }

        .groupArrow {
          background: #fff;
          color: #97c11c;
        }
      }
    }

    .groupTitleBox {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      border-radius: 0;
      padding: 0;
      margin-bottom: 0;
      flex: 1;
      justify-content: flex-start;
    }

    .groupTitleText {
      font-size: 16px;
      font-weight: bold;
      color: #97c11c;
      margin-right: 0;
      text-align: left;
      transition: color 0.3s ease;
    }

    .groupArrow {
      background: #97c11c;
      color: #fff;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      transition: all 0.3s ease;
      flex-shrink: 0;
    }

    .groupArrow.expanded {
      transform: rotate(0deg);
    }

    .modelCardsContainer {
      display: flex;
      flex-wrap: nowrap;
      gap: 10px;
      overflow-x: auto;
      padding: 5px 0;
      -webkit-overflow-scrolling: touch;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 100%;
        height: 2px;
        background-color: #97c11c;
      }

      /* 隐藏滚动条 */
      &::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .groupSeparator {
      height: 2px;
      background: linear-gradient(90deg, #e0e0e0 0%, #97c11c 50%, #e0e0e0 100%);
      margin: 15px 0;
      position: relative;
      overflow: hidden;
      display: block;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent 0%, #97c11c 50%, transparent 100%);
        animation: separatorFlow 3s ease-in-out infinite;
      }
    }
  }

  .el-card__body {
    padding: 5% !important;
  }

  .modelSelectCard {
    width: 115px;
    min-width: 160px;
    border-radius: 6px;
    cursor: pointer;
    opacity: 1;
    background: #fff;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    padding: 0;
    height: 160px;

    &::before {
      display: none;
    }

    .modelTitle {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0;
      font-size: 12px;
      text-align: center;
      font-weight: 600;
      width: 100%;
      color: #fff;
      text-shadow: none;
      background: #97c11c;
      padding: 6px 8px;
      z-index: 2;
    }

    .modelSelectImage {
      display: block;
      width: 70%;
      height: calc(100% - 42px);
      border-radius: 6px 6px 0 0;
      box-shadow: none;
      transition: transform 0.3s ease;
      position: relative;
      z-index: 1;
      object-fit: cover;
      object-position: center top;
      margin: 0 auto;
      margin-top: 8px;
    }
  }

  .modelSelectCard:hover {
    opacity: 1;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background: #f8f9fa;

    .modelSelectImage {
      transform: scale(1.02);
    }
  }
}

.modelSelectMenu {
  margin: 0px;
  position: absolute;
  width: 100%;
  bottom: 0px;
  white-space: nowrap;
  padding: 5px;
  z-index: 12;

  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .modelSelectMenuArrow {
    width: fit-content;
    display: block;
    height: 18px;
    background-color: #97c11c;
    border-radius: 0px 5px 0px 0px;
    z-index: 99;
    color: white;
    padding-left: 5px;
    padding-right: 5px;
    cursor: pointer;

    div {
      display: inline-block;
      font-size: 12px;
      padding-top: 3px;
      padding-bottom: 3px;
    }
  }

  .modelSelectMenuBar {
    width: 100%;
    height: 2px;
    display: block;
    background-color: #97c11c;
  }

  .container {
    height: 115px;
    width: 100%;
    display: block;
    background: #ffffff;

    .modelSelectCard {
      display: inline-block;
      height: calc(90% - 20px);
      aspect-ratio: 1;
      margin: 0.2% 0.5% 0 0.5%;
      cursor: pointer;
      opacity: 1;
      padding: 0.5%;

      .modelTitle {
        margin-bottom: 3px;
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        width: 100%;
      }

      .modelSelectImage {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
      }
    }
  }

  .modelSelectCard:hover {
    opacity: 0.7;
  }
}

.mobileBottomSelectMenu {
  margin: 0px;
  position: fixed;
  width: 100%;
  bottom: 0px;
  white-space: nowrap;
  padding: 5px;
  z-index: 12;
  background-color: rgba(255, 255, 255, 0.95);
  /* 白色半透明背景 */

  .menuSegment {
    position: relative;
    border-top: 1px solid rgb(225, 225, 225);
    height: 52px;
    display: block;

    .title {
      width: 100%;
      text-align: center;
      margin-top: 15px;

      .arrow {
        position: absolute;
        left: 12px;
        top: 15px;
      }
    }

    .colorsContent {
      max-height: 60vh;
      overflow-y: auto;
      margin: 5px -5px -5px -5px;
      background-color: #fff;

      .colorTrendsCategoryList {
        padding: 4px 8px 10px;
        background: #fff;
      }

      .colorTrendsCategory {
        margin-bottom: 4px;
        border-bottom: 1px solid #e9eedc;
      }

      .colorTrendsCategoryTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 32px;
        padding: 0 6px;
        color: #52623c;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
      }

      .colorTrendsCategoryTitle i {
        color: #97c11c;
      }

      .colorTrendsCategory .materialArea {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 4px;
        padding: 4px 0 8px;
      }

      .colorTrendsCategory .materialSelectCard {
        min-width: 0;
        margin: 0;
        padding: 2px;
        cursor: pointer;
      }

      .colorTrendsCategory .materialCode {
        min-height: 28px;
        color: #52623c;
        font-size: 9px;
        line-height: 14px;
        overflow-wrap: anywhere;
        white-space: normal;
      }

      .colorTrendsCategory .materialPreview {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
        object-fit: contain;
        display: block;
      }

      .flexBoxArea {
        margin-left: -10px;
        margin-right: -10px;
        padding-left: 10px;
        padding-right: 10px;
        background: #fff;
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 4px;
        width: auto;
        overflow-x: hidden;

        ::-webkit-scrollbar {
          display: none;
        }

        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;

        /* Firefox */
        .groupSelectCard {
          display: block;
          padding: 5px;
          padding-left: 10px;
          padding-right: 10px;
          border: 1px solid #97c11c;
          color: #97c11c;
          border-radius: 2px;
          margin: 3px;
        }

        .selected {
          border: 2px solid #97c11c;
          font-weight: bold;
          color: #fff;
          background-color: #97c11c;
        }

        .materialSelectCard {
          padding: 0px;
          margin: 0;
          min-width: 0;
        }

        .materialPreview {
          width: 40px;
          height: 40px;
        }
      }
    }

    .modelsContent {
      background-color: #fff;

      ::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none;
      /* IE and Edge */
      scrollbar-width: none;
      /* Firefox */
      height: 90px;
      display: flex;
      flex-wrap: nowrap;
      width: auto;
      overflow-x: auto;
      margin-left: -10px;
      margin-right: -10px;
      padding-left: 10px;
      padding-right: 10px;
      background: #fff;

      .modelSelectCard {
        display: inline-block;
        height: 90%;
        aspect-ratio: 1;
        margin: 0.5% 0.5% 0 0.5%;
        cursor: pointer;
        opacity: 1;
        padding: 0.5%;

        .modelTitle {
          margin-bottom: 3px;
          font-size: 12px;
          text-align: center;
          font-weight: bold;
          width: 100%;
        }

        .modelSelectImage {
          display: block;
          margin-left: auto;
          margin-right: auto;
          width: 100%;
        }

        .selected {
          // box-shadow:  #97c11c 0px 0px 30px -12px;
          border: 1px solid #98c11c77;
          border-radius: 5px;
          opacity: 0.7;
        }
      }
    }
  }
}

.empty {
  height: 200px;
  padding: 100px;
  display: block;
  margin: auto;
  text-align: center;
  color: #7d7d7d;
}

.modelViewer {
  position: relative;
}

.mobileTopMenu {
  display: flex;
  justify-content: space-between;
  background-color: #dedede46;
  height: 35px;
  width: 100%;
  color: #97c11c;
  font-weight: bold;
  position: relative;
  z-index: 1000;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
  border-bottom: 1px solid rgb(225, 225, 225);

  .titleText {
    font-size: 18px;
    margin: 2px;
    padding: 4px;
  }
}

.topMenu {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  z-index: 1000;

  display: flex;
  justify-content: space-between;

  .backButton {
    background-color: #ffffff;
    border: 1px solid #97c11c;
    font-weight: bold;
    border-radius: 8px;
    color: #97c11c;
    font-size: 20px;
    margin: 20px;
    padding: 0px;
    cursor: pointer;
    height: 56px;
    z-index: 11;

    .backArrow {
      background-color: #dedede;
      border-radius: 8px 0px 0px 8px;
      height: 100%;
      padding: 15px 3px 15px 3px;
      display: inline-block;
    }

    .backButtonText {
      display: inline-block;
      padding: 15px;
      height: 100%;
    }
  }

  .backButton:hover {
    background-color: #97c11c;
    color: #ffffff;

    .backArrow {
      background-color: #799a17;
    }
  }

  .rightMenu {
    z-index: 11;

    .modelTitle {
      font-size: 20px;
      width: 80%;
      margin: 20px;
      text-align: right;
      color: #799a17;
      font-weight: bold;
      z-index: 11;
    }

    .titleText {
      cursor: pointer;
      padding: 5px;
      background-color: #ffffff;
      border-radius: 5px;
    }

    .downloadButton {
      margin-right: 15px;
      margin-top: 5px;
      height: 60px;
      width: 60px;
      cursor: pointer;
    }
  }
}

.sharingWindowContentBlocker {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: white;
  z-index: 12;
  opacity: 0.5;
  top: 0;
  left: 0;
}

.sharingWindow {
  z-index: 13;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 176px;
  transform: translate(-50%, -80%);
  display: block;
  background-color: #ffffff;
  opacity: 1;
  border: 1px solid #97c11c;
  border-radius: 15px;
  padding: 10px;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;

  /* Standard syntax */
  .sharingTitle {
    position: relative;
    text-align: center;
    padding-top: 5px;
    color: #799a17;
  }

  .sharingCloseButton {
    position: absolute;
    right: 5px;
    top: 5px;
    margin: 0px;
    padding: 0px;
  }
}

.arButton {
  z-index: 12;
  position: absolute;
  display: flex;
  justify-content: space-around;
  color: white;
  background-color: #97c11c;
  padding: 1px;
  border-radius: 25px;
  font-weight: 450;
  left: 40%;
  top: 95%;
  cursor: pointer;
  font-size: 22px;
  transform: translate(-40%, -50%);
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

#emersyaMainViewer {
  display: block;
}

.iframeLoadingScreen {
  border: none;
  display: block;
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  cursor: wait;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    padding: 0;
    background: transparent;
    opacity: 1;
  }

  .colorTrendsLoadingLogo {
    display: block;
    width: 540px;
    max-width: 60vw;
    height: 540px;
    max-height: 60vw;
    aspect-ratio: 1 / 1;
    flex-shrink: 0;
    animation: colorTrendsTigerLoading 2200ms ease-in-out infinite;
  }
}

@keyframes colorTrendsTigerLoading {
  0%,
  100% {
    opacity: 0.42;
    filter: blur(5px);
    transform: scale(0.96);
  }

  42% {
    opacity: 1;
    filter: blur(0);
    transform: scale(1);
  }

  68% {
    opacity: 0.82;
    filter: blur(2px);
    transform: scale(0.99);
  }
}

@media (prefers-reduced-motion: reduce) {
  .iframeLoadingScreen .colorTrendsLoadingLogo {
    animation: none;
    opacity: 1;
    filter: none;
  }
}

.productInfoMinimized {
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 300px;
  padding: 15px;
  background-color: #97c11c;
  color: #ffffff;
  display: flex;
  border-radius: 8px;
  cursor: pointer;

  .el-icon-arrow-up {
    position: absolute;
    font-size: 20px;
    right: 20px;
  }
}

.closedCustomize {
  cursor: pointer;
  z-index: 9999;
  height: 100%;
  width: 111px;
  border-right: 3px solid #97c11c;
  position: absolute;
  right: 0px;
  top: 0px;

  i {
    background-color: #97c11c;
    color: #ffffff;
    border-bottom-left-radius: 5px;
    padding: 3px;
    font-weight: bold;
    cursor: pointer;
    display: block;
    text-align: center;
  }
}

.materialSelectorArea {
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 1000;
  display: flex;
  flex-flow: column;
  width: 500px;
  height: 95%;
  border: 5px solid #ffffff;

  .materialBox {
    border-left: 1px solid #97c11c;
    border-right: 1px solid #97c11c;
    padding: 20px;
    flex: 1 1 auto;
    background-color: #fff;
    overflow-y: auto;

    .colorTrendsCategory {
      background-color: #fdfdfd;
      margin: 5px 0px 5px 0px;
      padding: 5px;
      border-radius: 5px;

      .colorTrendsCategoryTitle {
        display: block;
        position: relative;
        min-height: 28px;
        margin: 5px 5px 5px 10px;
        color: #52623c;
        font-size: 15px;
        font-weight: 600;
        line-height: 28px;
        cursor: pointer;

        span {
          display: inline-block;
        }

        i {
          position: absolute;
          right: 8px;
          top: 5px;
          color: #97c11c;
        }
      }

      .colorTrendsCategoryTitle:hover {
        font-weight: bold;
      }

      .materialArea {
        display: flex;
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 8px;

        .materialSelectCard {
          cursor: pointer;
          width: auto;
          margin: 0;
          min-width: 0;
          font-size: 10px;

          .materialCode {
            color: #52623c;
            min-height: 32px;
            font-size: 11px;
            line-height: 16px;
            overflow-wrap: anywhere;
            white-space: normal;
          }

          .materialPreview {
            margin-top: 3px;
            width: 100%;
            height: auto;
            aspect-ratio: 1 / 1;
            object-fit: contain;
            display: block;
          }
        }

        .materialSelectCard:hover {
          border: 1px solid #97c11c;
        }
      }
    }
  }

  .productInfoBox {
    border-left: 1px solid #97c11c;
    border-right: 1px solid #97c11c;
    padding: 20px;
    flex: 0 1 auto;

    .productInfo {
      margin-bottom: 4px;
    }

    .productInfoValue {
      text-align: right;
      font-size: 20px;
    }

    .productInfoKey {
      text-align: left;
      font-size: 18px;
    }

    .colorPreview {
      width: 100%;
      height: 70px;
      display: block;
      border: 1px dashed #97c11c;
    }
  }

  .sectionTitle {
    // auto height
    flex: 0 1 auto;
    background-color: #97c11c;
    width: 100%;
    color: #ffffff;
    font-weight: bold;
    border-radius: 8px;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px 10px 0px;
  }
}

/* 响应式样式 - PC端竖屏优化 */
@media (max-width: 1200px) and (min-width: 819px) {
  .modelSelectionArea {
    .modelGroup {
      .groupHeader {
        min-width: 287px;
        max-width: 373px;
        margin-right: 20px;
        padding: 15px;
        height: 140px;
        /* 与模型卡片高度保持一致 */

        &::after {
          bottom: -13px;
          /* 调整分割线位置以对齐 */
        }
      }

      .modelCardsContainer {
        min-width: 350px;
        gap: 12px;

        &::after {
          bottom: 8px;
          /* 调整模型图片下方分割线位置 */
        }
      }

      .modelSelectCard {
        width: 140px;
        min-width: 140px;
        height: 140px;

        .modelTitle {
          font-size: 12px;
          padding: 6px 8px;
        }

        .modelSelectImage {
          height: calc(100% - 42px);
          margin-top: 8px;
        }
      }
    }
  }
}

@media (max-width: 1000px) and (min-width: 819px) {
  .modelSelectionArea {
    .modelGroup {
      .groupHeader {
        min-width: 293px;
        max-width: 333px;
        margin-right: 15px;
        padding: 12px;
        height: 120px;
        /* 与模型卡片高度保持一致 */

        &::after {
          bottom: -11px;
          /* 调整分割线位置以对齐 */
        }

        .groupTitleText {
          font-size: 16px;
        }
      }

      .modelCardsContainer {
        min-width: 300px;
        gap: 10px;

        &::after {
          bottom: 10px;
          /* 调整模型图片下方分割线位置 */
        }
      }

      .modelSelectCard {
        width: 120px;
        min-width: 120px;
        height: 120px;

        .modelTitle {
          font-size: 11px;
          padding: 5px 6px;
        }

        .modelSelectImage {
          height: calc(100% - 36px);
          margin-top: 6px;
        }
      }
    }
  }
}

/* 额外的微调以确保分割线在各种屏幕尺寸下完美对齐 */
@media (max-width: 950px) and (min-width: 819px) {
  .modelSelectionArea {
    .modelGroup {
      .groupHeader {
        &::after {
          bottom: -10px;
          /* 进一步微调分割线位置 */
        }
      }

      .modelCardsContainer {
        &::after {
          bottom: 11px;
          /* 相应调整模型图片下方分割线 */
        }
      }
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #c0c0c0;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #97c11c;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #799a17;
}

html,
body {
  height: 100%;
  margin: 0;
}

/* 分割线滚动动画 */
@keyframes separatorFlow {
  0% {
    left: -100%;
  }

  50% {
    left: 0%;
  }

  100% {
    left: 100%;
  }
}

/* 移动端行业选择下拉框样式 */
.mobile-industry-dropdown {

  /* 控制整个下拉框的宽度与选择框保持一致 */
  @media (max-width: 818px) {
    width: 353px !important;
    min-width: 353px !important;
  }

  @media (max-width: 640px) and (min-width: 481px) {
    width: 353px !important;
    min-width: 353px !important;
  }

  @media (max-width: 480px) {
    width: 353px !important;
    min-width: 353px !important;
  }

  .el-select-dropdown__item {
    padding: 16px 24px;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    transition: all 0.3s ease;
    line-height: 1.4;
    min-height: 48px;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #f0f9e6;
      color: #97c11c;
    }

    &.selected {
      background-color: #97c11c;
      color: #fff;
      font-weight: 600;
    }
  }

  .el-select-dropdown__list {
    padding: 12px 0;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border: 1px solid #e8e8e8;
    max-height: 300px;
  }
}
</style>
